import * as React from "react";
const WebScrapingImg = (props) => (
  <svg
    id="bec3214f-247e-4f62-bd32-d0a4f7ed7242"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={865.76}
    height={682.89}
    viewBox="0 0 865.76 682.89"
    {...props}
  >
    <g
      id="b9735038-2446-451c-a913-0f7845df3515"
      data-name="freesvgillustration--background-complete--inject-30"
    >
      <rect x={543.8} y={359.2} width={236.44} height={14.44} fill="#ebebeb" />
      <rect
        x={564.87}
        y={373.62}
        width={194.26}
        height={39.83}
        fill="#ebebeb"
      />
      <polygon
        points="759.15 381.5 564.87 385.35 564.87 373.62 759.15 373.62 759.15 381.5"
        fill="#c7c7c7"
      />
      <path
        d="M729.93,406H594.11V381.14H729.93Zm-134.11-1.7H728.23V382.84H595.82Z"
        fill="#dbdbdb"
      />
      <rect x={639.91} y={390.19} width={44.21} height={6.68} fill="#dbdbdb" />
      <polygon
        points="563.3 642.49 556.88 642.49 575.6 413.45 592 413.45 563.3 642.49"
        fill="#ebebeb"
      />
      <polygon
        points="592 413.46 590.07 428.77 574.35 428.77 575.6 413.46 592 413.46"
        fill="#c7c7c7"
      />
      <polygon
        points="760.72 642.49 767.15 642.49 748.45 413.45 732.03 413.45 760.72 642.49"
        fill="#ebebeb"
      />
      <polygon
        points="732.03 413.46 733.95 428.77 749.69 428.77 748.45 413.46 732.03 413.46"
        fill="#c7c7c7"
      />
      <path
        d="M735.08,132.22a49.43,49.43,0,1,1,22.68-53.51A49.44,49.44,0,0,1,735.08,132.22Z"
        fill="#ebebeb"
      />
      <path
        d="M724.7,84.48a15,15,0,1,1-14.87-15.23A15,15,0,0,1,724.7,84.48Z"
        fill="#fff"
      />
      <path
        d="M735.15,126v6.21a49.48,49.48,0,0,1-52-.65l.09-6.17a26,26,0,0,1,52,.61Z"
        fill="#fff"
      />
      <path
        d="M155.65,214.62a32.42,32.42,0,1,1,14.85-35A32.39,32.39,0,0,1,155.65,214.62Z"
        fill="#ebebeb"
      />
      <path
        d="M148.85,183.36a9.86,9.86,0,1,1-9.74-10A9.86,9.86,0,0,1,148.85,183.36Z"
        fill="#fff"
      />
      <path
        d="M155.7,210.64v4.06a32.38,32.38,0,0,1-34.1-.43v-4a17.05,17.05,0,0,1,34.1.41Z"
        fill="#fff"
      />
      <path
        d="M187.91,387.41a62.75,62.75,0,0,0,.2,8.34c-.1-1.84-.12-3.7-.15-5.56C187.93,389.27,187.91,388.33,187.91,387.41Z"
        fill="#ebebeb"
      />
      <path
        d="M155,538.13a100.17,100.17,0,0,0,16.33-24.67l1-1.26c31.42,9.67,43.7-23.24,42.93-23.29-9.38-.73-17.65-1-26,3.87a47.82,47.82,0,0,0-15.91,16,124.92,124.92,0,0,0,8.15-28.41h.15c7.35-4.18,15.52-9.77,18.59-18s.47-19.54-1.28-28a.45.45,0,0,0-.49-.4.47.47,0,0,0-.35.24h0c-12.27,12.57-22.16,26.16-17.59,44-4.64,22-13.64,39.35-26.48,57.31A200.18,200.18,0,0,1,144.45,455c.31-3.32.71-6.61,1.18-9.89a1.08,1.08,0,0,0,.49-.15,180.53,180.53,0,0,0,27-20.65l1.06-.63c15.79,15.19,36.33,2.2,51.15-7.45v-.08a.84.84,0,0,0,.41-1.09.85.85,0,0,0-.53-.45h-.14a.73.73,0,0,0-.25-.08c-9.7-3.07-18.62-7.44-29-5a42.76,42.76,0,0,0-14.59,6.82,144.77,144.77,0,0,0,30.28-46.27.79.79,0,0,0,.37-.1c18.21-9.28,26-24.83,23.87-44.72l.31-.48c.27-.44-.41-.84-.73-.48-11.55,12.53-28.82,22.59-23.6,41.71a264.12,264.12,0,0,1-17.27,28.76c5.88-16,6-30.69-1.83-47.74a.6.6,0,0,0-.35-.77.55.55,0,0,0-.36,0,.33.33,0,0,0-.29.13h0a60.35,60.35,0,0,0-13.54,34.31c-.53,9.32,3.87,16.14,10.44,22.16A171.34,171.34,0,0,1,146,442.36c5.7-37.32,21-71.95,35.47-106.69a.21.21,0,0,0,.17-.09c7.72-6.48,18.36-11.81,22.74-21.39,4.76-10.41,2.51-23.87,1.37-34.84,0,0-.57-.24-.57-.1C197,287,188.16,295.57,183.48,306c-4,9.07-3.74,18.75-3.41,28.4l-.11.1a.19.19,0,0,0,0,.27.19.19,0,0,0,.09,0v1.47q-6.3,11.93-11.84,24.22c.62-8.69,1.71-17.78-.59-26.05-2.73-10.23-16.49-28.37-16.58-28.37s-.2,0-.17.1h0c0,.24-.2,1.08-.18,1.15-3.41,22-10.47,47.34,15.68,57.18h0c-18.31,42.49-29.19,88.2-24.14,132.61-16-25.49-22.61-53.09-25.57-83a.51.51,0,0,0,.28-.31c4.05-10.23,8.33-21.55,7.51-32.75-.79-10.59-6.35-20.65-10.8-30.09a.59.59,0,0,0-.79-.28.63.63,0,0,0-.28.28c-5.4,12-11.42,22.86-10.67,36.5.61,11.05,6.63,17.05,13.88,24.79V413l-.12.51a.58.58,0,0,0,.17.62A172.82,172.82,0,0,0,122,461.71c-3.41-8.52-5.78-16.86-11.94-24.09a161.89,161.89,0,0,0-23.78-22,.47.47,0,0,0-.65.09.46.46,0,0,0,0,.61l.19.17c.85,10.67,1.84,24.14,7.67,33.62,6.28,10.23,18,13.13,29.16,14.7h.12a93.19,93.19,0,0,0,19.77,35.1,177.45,177.45,0,0,0,22.73,67.25c.44.75,1.71.08,1.36-.72A242.53,242.53,0,0,1,155,538.13Zm33-42.47c8.89-6,16.46-4.79,25.89-5.32-5.12,6.63-8.1,12.43-15.18,16.85-7.65,4.75-16.84,4.07-25.57,3.92,4.57-5.51,8.85-11.39,14.86-15.45Zm-6.13-17.48a.61.61,0,0,0-.4-.66c-.68-9.17-.92-16.54,4.44-25,3.73-5.89,7.94-11.55,12.19-17,.34,7.68,1.87,15.48.53,23.06-1.59,9.07-9,15.35-16.76,19.7Zm40.92-138.83c4.31-4.26,8.81-8,12.2-12.89-1.38,8.53-.66,16.71-5.35,24.52a47.5,47.5,0,0,1-16.3,15.62c-1.76-10.88,1.62-19.56,9.43-27.25Zm-34.7,56.4a36.73,36.73,0,0,0,.46,4,38.28,38.28,0,0,1-5.81-23c.71-10.13,6.3-18.55,9.08-28.06v.37A127.21,127.21,0,0,0,188,375.68c-.19,3.91-.19,7.83-.12,11.73.12-4,.48-8,.66-11.73a169,169,0,0,1,3.41-25c.45,8.22,2.19,16.27,1.71,24.57a138.33,138.33,0,0,1-4.45,25.39l-.34-.39a37.67,37.67,0,0,1-.79-4.47Zm8.78-24.55c.61,10.55-3.82,20.2-7.3,29.92l-.2-.26a145.5,145.5,0,0,0,4.7-24.84,118.64,118.64,0,0,0-2-26.13l.11-.45c1.58,7.15,4.19,14.43,4.63,21.76Zm-15.14.82c2-8.22,5.66-15,9.48-22.27-3.41,9.65-8.87,18.4-9.07,29a37.22,37.22,0,0,0,4.74,19.19c-6-7.71-7.93-14.51-5.17-25.9Zm14.8,39.81c9.29-2.17,17.32,1.87,26.09,3.92-7.29,4.82-14.7,10.55-23.35,12.12s-16.18-1-23.68-5C182.4,418.65,188.5,413.65,196.57,411.83ZM186.34,305.39c4.23-9.36,10.64-16.57,17.37-24a127.29,127.29,0,0,0-21.29,45c.77-7.07.85-14.1,4-21.09Zm-4.77,27.28c.17-.86.3-1.71.42-2.54a144.25,144.25,0,0,1,21.89-48.05,358.86,358.86,0,0,0-21.7,49.85Zm.8-.92a458.18,458.18,0,0,1,22.38-50.91c-1.7,9.31-2.26,19.16-5.78,28s-10.33,15.78-16.53,22.88Zm16.86-22c3.82-9.09,4.74-19.78,6-29.52,0,9.84.48,23.77-3.41,32.74-3.72,8.52-12.26,13.72-19.3,19.42C188.71,325.45,195.6,318.29,199.23,309.74Zm-47.74-1.49v-.42c4.21,8.3,9.82,15.34,12.84,24.67,2.78,8.52,2.59,19.28,2.37,28.62a103.11,103.11,0,0,0-2.06-15.56h-.11c.87,5.5,1.37,11,1.71,16.53-3.84-8.64-8.53-16.91-11.1-26.08a98,98,0,0,1-3.65-26.48c4.38,11.22,11.08,21.11,12.63,33.45h0C162.85,330.86,156.86,319.08,151.49,308.25Zm.53,14.1a105.07,105.07,0,0,0,2.64,13.83,133.73,133.73,0,0,0,11.6,26.9,46.8,46.8,0,0,1-14.75-23.56c-2.07-8.52-1.26-17.46-.62-26.22.29,3.05.79,6.09,1.2,9.05Zm-3.1,12a85.19,85.19,0,0,1,.76-11.94,55.08,55.08,0,0,0,2,19.07,45.24,45.24,0,0,0,14.6,21.8v.56c-10.9-7.21-17-16-17.33-29.49Zm-44.59,51.15c-.17-10.69,8.65-31.66,8.65-31.66.54.3,8.37,21.55,8.93,25.88,1.33,10.41-2.58,22.16-5.85,32.12-4.43-9.5-11.49-14.77-11.66-26.41Zm-11.73,58c-3.22-8.53-4.09-17.7-6.22-26.47,7.58,7,15.53,13.64,22.26,21.44,6.4,7.41,8.53,16.3,13.12,24.51-12.54-2.64-24.06-6.29-29.09-19.47Z"
        fill="#ebebeb"
      />
      <path
        d="M227.09,348.91a100.22,100.22,0,0,0,7.64-22l.52-.76a.1.1,0,0,0-.06-.13.1.1,0,0,0-.09,0l-.29.32a.16.16,0,0,0-.24,0l0,0a.09.09,0,0,0-.12,0l-.75,1.28c-10,11.2-18.59,23.87-20.94,38.82l-.8.84h0l.7-.75a12,12,0,0,1-.24,1.56s.1.11.12,0a9.42,9.42,0,0,1,.27-1.7l.53-.56c-.12.34-.24.7-.34,1s.21.23.27,0l.8-1.88C219,360.13,223.88,355.29,227.09,348.91Zm7-21.1a118.61,118.61,0,0,1-7.41,20.93A69.54,69.54,0,0,1,214.2,365c5.4-12.59,12.85-24.13,19.25-36.25Zm-21.24,38.56a54.18,54.18,0,0,1,7.89-20.95c3.28-5,7.2-9.55,10.85-14.27-3.19,5.47-6.23,11-9.3,16.55-3.27,5.85-6.82,11.68-8.88,18.08Z"
        fill="#ebebeb"
      />
      <path
        d="M224.53,415.89l-1.35-.29h-.3l.22-.36h0l-.38.24c-7.6-1.71-15.34-2.9-23.18-1.71a74.81,74.81,0,0,0-23.87,8.71l-1.2-.54h0l1.15.54h-.19l-.56.19v.12h0v.12l.95-.41a41.06,41.06,0,0,0,23.05,3.33A46.93,46.93,0,0,0,211,422.11c3.8-1.71,8.34-3.53,11.52-6.34l2,.42C224.68,416.31,224.8,415.94,224.53,415.89Zm-25.05-1.71a61,61,0,0,1,21,1.25,131.35,131.35,0,0,0-43.24,6.46c7.13-3.16,14.51-6.53,22.21-7.69Zm-23.61,8.34h.1a147.89,147.89,0,0,1,46-6.82h.2C208.28,425.13,191.59,429.29,175.87,422.52Z"
        fill="#ebebeb"
      />
      <path
        d="M182.18,478.07v.15s.1.1.12,0a3.05,3.05,0,0,0,0-.43c5.11-5.33,10-11.13,12.6-18.09,2.83-7.53,3-15.63,3-23.58l.38-.54c0-.09,0-.17-.12-.1l-.26.34v-.28h0v.4c0,.12-.37.49-.54.75l.61-1.49s0-.12-.09,0c-.46.84-.88,1.71-1.29,2.54-8.76,11.85-15,25.22-14.77,40.31l-1.07,1.16c-.1.13,0,.32.19.19l.9-.93v1.06a.18.18,0,0,0,.36,0h0Zm3.9-21.44a80.13,80.13,0,0,1,9.72-17.32c-2.2,4.72-4,9.58-5.86,14.48H190c2.1-5.44,4.55-10.71,6.82-16.06l1-1.42c-.35,7.33-.61,14.87-2.88,21.89-2.44,7.49-7.29,13.32-12.46,19a97.82,97.82,0,0,1,5.4-17.81h0a87.75,87.75,0,0,0-5.52,18l-.19.22a65,65,0,0,1,4-21Z"
        fill="#ebebeb"
      />
      <path
        d="M214.35,490.26a.13.13,0,0,0,0-.19l0,0,.29-.34c0-.1,0-.24-.15-.13a3.59,3.59,0,0,0-.51.56l-.82.25a79.53,79.53,0,0,0-21,5.34c-6.72,3-11.94,7.79-17.05,13-.79.57-1.55,1.15-2.32,1.71v.12l1.24-.8-.47.49h0l.76-.72A183.06,183.06,0,0,1,212.08,491l1-.18a65.84,65.84,0,0,1-16.93,13.36c-7.83,4.23-15.5,5.76-24.21,6.82v.1c15.78.5,31.54-8.52,41.58-20.32l.56-.1a.25.25,0,0,0,.34-.1A.24.24,0,0,0,214.35,490.26ZM176.11,508c5-4.6,10.23-9.08,16.37-11.93a73.13,73.13,0,0,1,16.88-4.65A128.49,128.49,0,0,0,176.11,508Z"
        fill="#ebebeb"
      />
      <path
        d="M116.57,412.51v-.43a.27.27,0,0,0,.12-.35l-.17-.38c-.44-9.09-2-18-2.93-27.07-.94-9.67-.63-19.36-.63-29,.2-.89.41-1.7.59-2.66a.22.22,0,0,0-.19-.27.24.24,0,0,0-.27.15,141.87,141.87,0,0,0-4.07,16.9,58.56,58.56,0,0,0-1.55,14.27c.53,9.65,4.47,19.81,8.78,28.37a.24.24,0,0,0,.17.14v.39C116.42,412.71,116.57,412.59,116.57,412.51Zm-8.4-30.4c0-8.9,2.64-17.7,4.65-26.36a201.24,201.24,0,0,0,.33,28.53c.85,8.91,2.64,17.73,3.18,26.66C112.41,402,108.2,392,108.17,382.11Z"
        fill="#ebebeb"
      />
      <path
        d="M116.86,412.78c.39-9.72,4.18-18.63,3.31-28.49a78.87,78.87,0,0,0-5.86-24.57h-.11a82.14,82.14,0,0,1,5.61,26.62c.46,9-2.83,17.49-3.17,26.41C116.64,412.94,116.86,412.92,116.86,412.78Z"
        fill="#ebebeb"
      />
      <path
        d="M124.84,462.53a23.26,23.26,0,0,1-3-.41l-.75-.52c-5-7.32-9.38-15-15-21.86-6.26-7.67-12.4-15.65-19.35-22.71,0,0-.14,0-.09.08,6,7.28,12.17,14.48,18.18,21.78,5.74,6.93,10,14.71,15.24,22A92.6,92.6,0,0,1,101,443c-6.21-7.88-10.23-16.69-14.34-25.76h-.11c.11.42.26.85.38,1.26-.26-.68-.55-1.38-.85-2a.19.19,0,0,0-.26-.05.17.17,0,0,0-.08.19c3.24,9.85,3.93,21.43,10.41,29.89a43.12,43.12,0,0,0,25.25,16.2l.4.54c.13.19.46,0,.32-.19l-.19-.27.46.09.31.18c.1,0,.19,0,.2-.12.65.11,1.32.19,2,.24C125.23,463.18,125.23,462.57,124.84,462.53Zm-4-.59a41.82,41.82,0,0,1-26.08-18.66c-3.86-6.47-4.57-14.06-6.62-21.17,5.85,15.89,18.75,30.5,32.6,39.66A1,1,0,0,1,120.8,461.94Z"
        fill="#ebebeb"
      />
      <path
        d="M193.84,537.77s-1,8.87-2.37,21.49c-3.27,29.73-8.75,80.13-8.75,83.23H133.4c0-3.07-5.46-53.5-8.71-83.23-1.38-12.62-2.37-21.49-2.37-21.49Z"
        fill="#dbdbdb"
      />
      <path
        d="M193.84,537.77s-1,8.87-2.37,21.49H124.69c-1.38-12.62-2.37-21.49-2.37-21.49Z"
        fill="#c7c7c7"
      />
      <rect x={117.82} y={534.21} width={80.53} height={15.69} fill="#dbdbdb" />
    </g>
    <path
      d="M367.75,484.72,364,492.43s13.43,5.43,22,5.72l3.72-6Z"
      fill="#f9b499"
    />
    <path
      d="M358.6,420.15l3.15,7.71s15.14-.85,22.28-7.43l-2.85-8.28Z"
      fill="#f9b499"
    />
    <rect x={480.32} y={547.01} width={42.86} height={6.43} fill="#d1d3d4" />
    <polygon
      points="536.46 614.29 524.03 614.72 509.2 375.95 522.32 375.95 536.46 614.29"
      fill="#d1d3d4"
    />
    <rect x={470.89} y={375.15} width={12.86} height={239.57} fill="#d1d3d4" />
    <rect x={425.49} y={367.35} width={96.9} height={11.47} fill="#a7a9ac" />
    <rect x={440.46} y={376.86} width={11.14} height={237.86} fill="#bcbec0" />
    <polygon
      points="407.89 614.29 396.75 614.29 413.46 377.72 424.6 377.72 407.89 614.29"
      fill="#bcbec0"
    />
    <path
      d="M342.89,459.58l18.86-31.72S376,426.72,384,420.43c0,0,.86-3.14,3.15,0l7.71,24.29s-27.71,35.71-41.71,37.71c0,0-19.72,4.58-17.43-10.57C335.75,471.86,336,465.86,342.89,459.58Z"
      fill="#0071f2"
    />
    <path
      d="M379.46,423.86s2,16.29-5.14,27.15l-10.86,13.71s-.28-12-18.86-8.29l-1.71,3.15s14.29-4.29,18.86,8c0,0-12.29,14.43-26.29,6.71l.14,2s15,9.14,29.29-9.14l13.29-13.86,8.28-33.71s-1.71-1.43-2.43.85A47.26,47.26,0,0,1,379.46,423.86Z"
      fill="#fff"
      opacity={0.5}
    />
    <path
      d="M522.61,336.5c-1.61,1.54-4.09.47-4.09.47,0-19.3-32.76-25.4-32.76-25.4-6.67-1.39-15.05-2.6-23.87-3.62l-.31,0c-18.09-2.09-38-3.41-48.68-4l-.89-.05-1.65-.09h-.19l-1.26-.07-.93,0-.32,0-.82,0-1.34-.06-.34,0H405l1.22-56.11.56-25.67h0L370,240.47c-16.26,6.6-22.35,3-22.35,3l-9-7.22-37-29.85c-3.44-3.53,10.27-17,10.27-17,5.48-5.76,8.49-1.65,8.49-1.65l31.52,25.58a5.8,5.8,0,0,0,6.86.33l56.64-37.52c11.68-8.89,28.44-6.1,28.44-6.1,6.57,7.65,32-1.21,32-1.21,6-1,34,13.84,34,13.84,16.57,21.43,6,60,6,60l0,.06A99,99,0,0,1,518,254.12a.06.06,0,0,0,0,.06c3.71,26,5.58,74.16,5.58,74.16C524.43,333.12,523.73,335.43,522.61,336.5Z"
      fill="#0071f2"
    />
    <path
      d="M477.42,170.49c-19.45,23.83-31.37,23-31.37,23-7.62.54-6.1-7.87-4.39-13.21h0a44.65,44.65,0,0,1,1.61-4.26c3.18-9.53-4-16.28-4-16.28l26.21-15.88,4.77,4c.26,13.31,3.38,18.94,5.41,21.21A5.51,5.51,0,0,0,477.42,170.49Z"
      fill="#f9b499"
    />
    <path
      d="M442.48,163.75s2.78,11.11,9.53,5.16c0,0,5.16-2.78,18.27-21Z"
      fill="#f7a48b"
    />
    <path
      d="M477.42,170.49c-19.45,23.83-31.37,23-31.37,23-7.62.54-6.1-7.87-4.39-13.21-.12,1.85-.49,11.39,6,9.23,0,0,5.14,3.17,28.05-20.48A5.51,5.51,0,0,0,477.42,170.49Z"
      fill="#f7a48b"
    />
    <ellipse cx={442.48} cy={122.05} rx={34.94} ry={41.7} fill="#f9b499" />
    <ellipse cx={456.18} cy={134.76} rx={8.54} ry={9.53} fill="#f9b499" />
    <path
      d="M408.73,111.33s-11.92-1.19-6-13.11c0,0,27.8-43.28,58.77-15.09,0,0,9.53-1.58,15.88,8,0,0,17.48,11.91,9.53,33.35,0,0-1.19,13.5-8.73,11.12,0,0,0,12.31-7.94,12.31,0,0,7.94-21.44-14.1-22.63,0,0-8.54.79-8.54,9.53,0,0,.4-12.71-14.29-14.3C433.35,120.46,422.62,120.46,408.73,111.33Z"
      fill="#2f2e41"
    />
    <g opacity={0.2}>
      <path d="M411.11,97.83c-.62,1.08-1.19,2.16-1.71,3.25a21.3,21.3,0,0,0-1.27,3.35,11.11,11.11,0,0,0-.42,3.48,9.09,9.09,0,0,0,1,3.42,6.34,6.34,0,0,1-1.8-3.32,9,9,0,0,1,.24-3.84,13.92,13.92,0,0,1,3.94-6.34Z" />
    </g>
    <path
      d="M416.67,115.7s24.22,4.76,38.91,2.38c0,0,13.5-2.38,21.05,7.94,0,0,3.57,6.75,7.94,6.36,0,0-.4,4.36-6.35,3.17,0,0,0,11.91-7.94,12.31,0,0,8.34-20.25-12.31-22.63,0,0-10.33-1.19-10.33,9.53,0,0-.4-13.5-14.29-14.3A42.84,42.84,0,0,1,416.67,115.7Z"
      opacity={0.2}
    />
    <path
      d="M522.72,335.61l-.11.89c-1.61,1.54-4.09.47-4.09.47,0-19.3-32.76-25.4-32.76-25.4-6.67-1.39-15.05-2.6-23.87-3.62l-.31,0c-16.28-2-37.41-3.4-48.68-4l-.89-.05-1.65-.09h-.19l-1.26-.07-.93,0-.32,0-.82,0-1.34-.06-.34,0H405l.86-56.12a2.45,2.45,0,0,1,.36,0c1.62.18,8.38,2.24,15.36,23.41,0,0,8,29.72,18.57,22.58,0,0,27.43-13.43,29.71-34.58,0,0,10.29-46,19.43-47.71l26.57,31.71,0,.06A35.18,35.18,0,0,1,518,254.12a.06.06,0,0,0,0,.06,42.61,42.61,0,0,1-7.3,25.15s-.57,4.57-16.29,18.85c0,0-8,6-.43,10.71a12,12,0,0,0,5.22,1.69C504.92,311.16,521.3,314.63,522.72,335.61Z"
      opacity={0.2}
    />
    <path
      d="M455.85,309.75l-6.79-7.4s7.46-.34,11.62,8.67c0,0-10.24,9.54-21.16,10.93,0,0,12.5-5.93,16.28-9.56A1.89,1.89,0,0,0,455.85,309.75Z"
      fill="none"
      stroke="#ed1c24"
      strokeMiterlimit={10}
    />
    <path
      d="M407.75,208.72l-1,12.95h0L370,240.47c-16.26,6.6-22.35,3-22.35,3l-9-7.22-.31-.41a20.68,20.68,0,0,0,2.2,1.54,23.94,23.94,0,0,0,25.91-.73Z"
      opacity={0.2}
    />
    <path
      d="M400.89,361.58s1.49-24.25,13.71-28.57l60.07-23.54s43.25,3.16,43.85,27.5c0,0-9.63,29.18-21.92,30.89l-40.28.57S431.46,430.15,414,457L396.6,485.29s5.15,2.57-.28,8.86c0,0-2.86,3.43-7.72,1.14L364.89,485s-1.71-.86-.57-6c0,0,1.71-7.43,5.71-6.29,0,0,4,0,8.86-22.29Z"
      fill="#2f2e41"
    />
    <path
      d="M459.18,360.43l-2.86,8,40.28-.57s11.55-.35,21.92-30.89c0,0,3.74-20.18-44.09-27.07L414.6,333s-5.14,2.28-5.71,5.14l36.86-.57s8-1.72,23.71-10.57c0,0,21.72-19.15,40.29,3.14,0,0,6.28,5.43-5.72,25.43A22.57,22.57,0,0,1,483.18,365S462.6,361.86,459.18,360.43Z"
      opacity={0.2}
    />
    <path
      d="M394.32,471l9.47-21.56,9.56-21.52,19.28-43,4.87-10.72,2.43-5.36c.8-1.78,1.63-3.59,2.59-5.32a48.26,48.26,0,0,1,15.82-17.4,33.59,33.59,0,0,1,10.85-4.73c3.9-.7,7.74-1.33,11.62-2L504,335.58l-23.14,4.34-11.56,2.14a32.63,32.63,0,0,0-10.57,4.76A48.36,48.36,0,0,0,443.32,364c-.94,1.71-1.74,3.48-2.54,5.27l-2.41,5.37-4.83,10.74-19.49,42.87-9.82,21.4Z"
      opacity={0.2}
    />
    <path
      d="M400.89,361.58S372,356.72,365.18,355L380,402.43s6.86,2.58,4.86,10.58c0,0-1.71,9.14-33.14,9.42,0,0-8-8-4.29-9.42l-32.28-44.58s-38.58-58.57,4.28-64.57l85.54-.41s55.26,2.77,69.43,6.45c0,0-42.68,16.25-59.83,23.11C414.6,333,404,334.72,400.89,361.58Z"
      fill="#2f2e41"
    />
    <path
      d="M316.6,304.15,327.46,333s2.29,8,12.86,4.85c0,0,20.28-5.14,24.86,17.15,0,0,21.71,4.28,35.71,6.57,0,0,2.29-23.43,13.71-28.57L405,303.45l-82.4.7S321.18,303.29,316.6,304.15Z"
      opacity={0.2}
    />
    <g opacity={0.2}>
      <path d="M347.46,413l8.23-2.42c2.74-.82,5.48-1.62,8.2-2.47s5.43-1.74,8.13-2.66c1.34-.48,2.69-.93,4-1.47s2.65-1.05,4-1.56a62.74,62.74,0,0,1-7.74,3.75c-2.66,1.09-5.37,2-8.1,2.89s-5.51,1.61-8.3,2.26S350.3,412.59,347.46,413Z" />
    </g>
    <g opacity={0.2}>
      <path d="M370,472.72c1.09.57,2.19,1.11,3.31,1.62s2.21,1.05,3.32,1.55l6.67,3.06c2.22,1,4.46,2,6.66,3.1s4.44,2.1,6.61,3.24c-1.17-.37-2.32-.8-3.48-1.21l-3.43-1.32c-2.29-.9-4.54-1.89-6.77-2.9s-4.44-2.1-6.6-3.28A51.2,51.2,0,0,1,370,472.72Z" />
    </g>
    <path
      d="M387.18,508.43,386,498.15a79.39,79.39,0,0,1-22-5.72L335.18,515s-22.77,2.22-17.67,20.61a5.05,5.05,0,0,0,.84,1.69c2.26,3,11.15,12,31.52,4.89a15.69,15.69,0,0,0,4.35-2.36l34-26.08a1.59,1.59,0,0,0,.48-1.89Z"
      fill="#0071f2"
    />
    <path
      d="M349.75,535s0-15.15-14.57-20l3.42-2.58s10,6,13.72,17.43c0,0,20.67-11.81,30.26-20.36a7.21,7.21,0,0,0,2.49-5.74c-.1-1.78-.8-3.52-3.12-3.61a8.87,8.87,0,0,1-1.77-.31c-3.24-.82-11.8-3.29-16.15-7.41a82.71,82.71,0,0,0,22,5.72l1.15,10.28S365.18,525,349.75,535Z"
      fill="#fff"
      opacity={0.5}
    />
    <path
      d="M319.18,531a22.13,22.13,0,0,0,2.81,2.5c.49.39,1,.73,1.51,1.1s1.06.66,1.6,1a21.17,21.17,0,0,0,6.95,2.47,11.16,11.16,0,0,0,1.83.22,10.3,10.3,0,0,0,1.84.07l1.85-.06,1.84-.27.93-.13c.3-.06.6-.16.9-.23l1.81-.5c1.2-.35,2.34-.88,3.55-1.28-1.1.6-2.22,1.22-3.38,1.74l-1.81.64c-.3.11-.6.23-.91.31l-.94.21c-.63.13-1.25.28-1.89.38l-1.93.14a11.32,11.32,0,0,1-1.93,0,12.4,12.4,0,0,1-1.93-.22,18.78,18.78,0,0,1-7.17-2.79A19.4,19.4,0,0,1,319.18,531Z"
      fill="#fff"
      opacity={0.5}
    />
    <rect x={409.6} y={543.58} width={33.86} height={6} fill="#bcbec0" />
    <path
      d="M263.67,150.84s-4.6,5.09,12.78,13.23l10.26,1.83-.73-15-8.07-8.8-.73,3.66Z"
      fill="#f7a48b"
    />
    <polygon
      points="479.03 315.15 442.93 327.56 445.18 333.15 480.75 319.86 479.03 315.15"
      fill="#0071f2"
    />
    <polygon
      points="479.03 315.15 442.93 327.56 445.18 333.15 480.75 319.86 479.03 315.15"
      fill="#fff"
      opacity={0.5}
    />
    <polygon
      points="436.6 312.58 479.03 315.15 442.93 327.56 436.6 312.58"
      fill="#e6e7e8"
    />
    <path
      d="M302.87,202.72c-4-4.49-14.33-16-18.08-20.19a6.87,6.87,0,0,0-2.92-1.93c-3.11-1-9.85-4.82-9.43-17.71,0,0-2.74-11.51.55-10.41a17.55,17.55,0,0,1,9,11s1.65-.27,1.1-2.74c0,0-4.11-14-12.06-10.14,0,0-6.58,9.59-7.4.28,0,0,6.1-15.63,17.85-11.4a4.58,4.58,0,0,1,2.78,2.93L293.11,170a8.44,8.44,0,0,0,2.45,3.76l18.13,16.12a6.63,6.63,0,0,1,1.71,7.71c-1.06,2.29-3.39,4.75-8.32,6.3A4,4,0,0,1,302.87,202.72Z"
      fill="#f9b499"
    />
    <path
      d="M266.59,146.25A11.54,11.54,0,0,1,270,145a11.27,11.27,0,0,1,3.59-.24,11.65,11.65,0,0,1-3.38,1.22A11.31,11.31,0,0,1,266.59,146.25Z"
      fill="#f7a48b"
    />
    <path
      d="M269.11,142.8a18,18,0,0,1,4.36-.86,17.43,17.43,0,0,1,4.44.13,16.94,16.94,0,0,1-4.36.86A17.44,17.44,0,0,1,269.11,142.8Z"
      fill="#f7a48b"
    />
    <path
      d="M304.82,204a19.86,19.86,0,0,0,4.79-1.39,9.92,9.92,0,0,0,3.84-2.85,9,9,0,0,0,1.95-4.32,9.14,9.14,0,0,0-.62-4.84,8.13,8.13,0,0,1,1.13,2.31,7.89,7.89,0,0,1,.26,2.61,8.58,8.58,0,0,1-1.95,4.87,9.31,9.31,0,0,1-4.33,2.94A12.58,12.58,0,0,1,304.82,204Z"
      fill="#0071f2"
    />
    <path
      d="M304.82,204a19.86,19.86,0,0,0,4.79-1.39,9.92,9.92,0,0,0,3.84-2.85,9,9,0,0,0,1.95-4.32,9.14,9.14,0,0,0-.62-4.84,8.13,8.13,0,0,1,1.13,2.31,7.89,7.89,0,0,1,.26,2.61,8.58,8.58,0,0,1-1.95,4.87,9.31,9.31,0,0,1-4.33,2.94A12.58,12.58,0,0,1,304.82,204Z"
      opacity={0.2}
    />
    <path
      d="M444.52,301.23c.78,1.59,6.69,13,17.48,16.26a.32.32,0,0,0,.42-.32c-.11-2.44-1.52-14.08-17.77-16.1A.12.12,0,0,0,444.52,301.23Z"
      fill="#0071f2"
    />
    <path
      d="M444.52,301.23c.78,1.59,6.69,13,17.48,16.26a.32.32,0,0,0,.42-.32c-.11-2.44-1.52-14.08-17.77-16.1A.12.12,0,0,0,444.52,301.23Z"
      opacity={0.3}
    />
    <path
      d="M433.62,307.73a52.05,52.05,0,0,1,15.44-5.38s7.28.18,11.62,8.67c0,0-10.41,9-21.16,10.93Z"
      fill="#f9b499"
    />
    <path
      d="M444.79,301.08c2.46.26,16.82,2.37,17.62,16.11a.27.27,0,0,0,.39.23c3.81-2,35.94-19.67,40.78-40.09l12.28-34.57s7.87-31.47-1.52-52.54a6.56,6.56,0,0,0-10.71-1.95,70.5,70.5,0,0,0-19.08,40,73.71,73.71,0,0,1-1.52,8.08L473,276a7.4,7.4,0,0,1-2.56,4l-25.76,20.77A.15.15,0,0,0,444.79,301.08Z"
      fill="#0071f2"
    />
    <polygon
      points="302.89 264.58 330.75 334.01 440.46 333.58 411.32 263.72 302.89 264.58"
      fill="#0071f2"
    />
    <polygon
      points="302.89 264.58 330.75 334.01 440.46 333.58 411.32 263.72 302.89 264.58"
      fill="#fff"
      opacity={0.5}
    />
    <polygon
      points="311.46 260.29 302.89 264.58 411.32 263.72 440.46 333.58 445.18 333.15 414.75 259.01 311.46 260.29"
      fill="#e6e7e8"
    />
    <rect x={558.9} y={435.41} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={551.92} y={435.41} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={551.92}
      y={435.41}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M609.3,453.14c-45.94,0-46,65.33,0,65.33S655.31,453.14,609.3,453.14Z"
      fill="#fff"
    />
    <path
      d="M637.24,491.93c-2.46,11.23-11.78,21-27.94,21-38.16,0-38.16-54.21,0-54.21h.75c-35.89.66-35.71,52,.7,52C625.59,510.71,634.44,502.12,637.24,491.93Z"
      fill="#0071f2"
    />
    <path
      d="M609.58,465.85a1.17,1.17,0,0,1,1.19,1.09v1.82a17,17,0,0,1,8.84,3.18c.46.33.7.6.7,1.05a1.22,1.22,0,0,1-1.29,1.13,1.33,1.33,0,0,1-.9-.31,14.73,14.73,0,0,0-7.45-3v12.72c7.54,1.42,10.72,4.05,10.72,8.48,0,4.82-4.41,8.24-10.62,8.48v3.54a1.21,1.21,0,0,1-1.33,1.06,1.19,1.19,0,0,1-1.06-1.06v-3.59a19.52,19.52,0,0,1-11.18-4.41,1.16,1.16,0,0,1-.55-.95,1.25,1.25,0,0,1,1.24-1.14,1.34,1.34,0,0,1,.91.32,16.73,16.73,0,0,0,9.68,4.14v-13c-7.45-1.51-10.53-4-10.53-8.55s4.36-8.1,10.43-8.24v-1.72A1.16,1.16,0,0,1,609.58,465.85Zm-1.06,17.29V470.71c-4.82.1-8,2.73-8,6S602.07,481.72,608.52,483.14Zm2.19,2.82v12.55c5-.1,8.2-2.73,8.2-6.19,0-3.19-1.78-5.1-8.24-6.41Z"
      fill="#0071f2"
    />
    <rect x={604.79} y={427.93} width={1.41} height={2.12} fill="#0071f2" />
    <path
      d="M606.2,423.83h-1.41v-4.11h1.41Zm0-8.21h-1.41v-4.11h1.41Z"
      fill="#0071f2"
    />
    <polygon
      points="606.2 407.41 604.79 407.41 604.79 405.81 603.26 405.35 603.67 403.99 606.2 404.77 606.2 407.41"
      fill="#0071f2"
    />
    <path
      d="M599.43,404.17,595.59,403l.41-1.41,3.84,1.16Zm-7.69-2.33-3.83-1.17.41-1.41,3.85,1.17Zm-7.67-2.34-3.83-1.18.41-1.41,3.83,1.16Zm-7.68-2.34L572.55,396l.42-1.41,3.83,1.17Zm-7.67-2.34-3.84-1.18.41-1.41,3.84,1.17Zm-7.67-2.33-3.85-1.18.41-1.41,3.85,1.17Zm-7.65-2.35L549.57,389l.41-1.41,3.84,1.17Z"
      fill="#0071f2"
    />
    <rect
      x={544.17}
      y={385.76}
      width={1.41}
      height={2.12}
      transform="translate(15.93 795.16) rotate(-73.04)"
      fill="#0071f2"
    />
    <path
      d="M544.76,384a2.65,2.65,0,1,0,1.77,3.32A2.65,2.65,0,0,0,544.76,384Z"
      fill="#0071f2"
    />
    <rect x={600.7} y={245.37} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={593.72} y={245.37} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={593.72}
      y={245.37}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M678.84,302.83a86.37,86.37,0,0,1-27.75,24.1,86.48,86.48,0,0,1-27.75-24.1c-9.78-12.93-9.3-33.17,4.68-37.55,15.46-4.84,23.07,18.38,23.07,18.38s7.71-23.42,23.08-18.38C688.09,269.82,688.57,289.92,678.84,302.83Z"
      fill="#fff"
    />
    <polygon
      points="640.17 316.73 635.96 299.17 633.22 305.37 616.19 305.37 616.19 303.39 631.94 303.39 636.53 293.04 639.82 306.72 644.46 278.37 648.56 300.8 651.81 291.43 656.92 306.76 658.05 303.37 686.01 303.37 686.01 305.35 659.48 305.35 656.91 313.01 651.76 297.58 647.96 308.56 644.57 289.96 640.17 316.73"
      fill="#0071f2"
    />
    <rect x={590.31} y={295.06} width={2.12} height={1.41} fill="#0071f2" />
    <path
      d="M586.33,296.47h-4v-1.41h4Zm-8,0h-4v-1.41h3.94Zm-8,0h-4v-1.41h4Zm-8,0h-4v-1.41h4Zm-8,0h-4v-1.41h4Zm-8,0h-4v-1.41h4Zm-8,0h-4v-1.41h4Z"
      fill="#0071f2"
    />
    <rect x={528.48} y={295.06} width={2.12} height={1.41} fill="#0071f2" />
    <circle cx={528.61} cy={295.77} r={2.66} fill="#0071f2" />
    <rect x={561.18} y={51.82} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={554.2} y={51.82} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={554.2}
      y={51.82}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <g
      id="f8ec710d-2cf7-46b6-980e-b72e70960a73"
      data-name="freesvgillustration--TEfYE6--inject-30"
    >
      <path
        d="M639.86,81.05l-1.51,1.41-23.94,22.8a3.6,3.6,0,0,1-5.06.44,3.66,3.66,0,0,1-.44-.44L584.35,82.11l-1-1a3.63,3.63,0,0,1,2.13-.56h16.62l34.68-.15A5.1,5.1,0,0,1,639.86,81.05Z"
        fill="#fff"
      />
      <path
        d="M639.79,123.45a11.73,11.73,0,0,1-2,.36c-6.63,0-13.25,0-19.88.1l-32,.13a4.69,4.69,0,0,1-2.58-.65l19.78-18.9,3.83,3.61,1.63,1.52a4.23,4.23,0,0,0,6,.12l.11-.12c1.76-1.65,3.49-3.33,5.32-5.08l19.78,18.67Z"
        fill="#fff"
      />
      <path
        d="M600.73,102.2c-6.43,6.27-13,12.34-19.32,18.63a4.18,4.18,0,0,1-.14-.93q-.09-17.5-.14-35a6.73,6.73,0,0,1,.12-1.1Z"
        fill="#fff"
      />
      <path
        d="M641.9,120.63l-7.25-6.89-11.76-11.1-.47-.36c6.48-6.31,13-12.4,19.34-18.65C642,84.31,642.18,119.7,641.9,120.63Z"
        fill="#fff"
      />
    </g>
    <rect x={609.02} y={158.67} width={1.41} height={2.12} fill="#0071f2" />
    <path
      d="M610.44,177.21H609v-4.1h1.42Zm0-8.21H609v-4.11h1.42Z"
      fill="#0071f2"
    />
    <polygon
      points="607.91 184.73 607.5 183.37 609.02 182.91 609.02 181.32 610.44 181.32 610.44 183.97 607.91 184.73"
      fill="#0071f2"
    />
    <path
      d="M537.64,206.13l-.41-1.42,3.9-1.18.42,1.41Zm7.81-2.38-.41-1.41,3.9-1.2.41,1.41Zm7.8-2.37-.41-1.42,3.91-1.18.41,1.41Zm7.82-2.38-.42-1.41,3.91-1.19.41,1.42Zm7.8-2.39-.41-1.34,3.9-1.19.41,1.35Zm7.8-2.37-.41-1.41,3.92-1.19.41,1.41Zm7.82-2.37-.41-1.42,3.9-1.18.41,1.41Zm7.8-2.38-.41-1.41,3.9-1.19.41,1.41Zm7.82-2.39-.41-1.34,3.9-1.19.41,1.35Z"
      fill="#0071f2"
    />
    <rect
      x={531.45}
      y={206.29}
      width={2.12}
      height={1.41}
      transform="translate(-37.18 163.84) rotate(-16.91)"
      fill="#0071f2"
    />
    <circle cx={531.63} cy={207.23} r={2.66} fill="#0071f2" />
    <rect x={180.14} y={440.55} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={280.94} y={440.55} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={280.94}
      y={440.55}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <g
      id="b02e6ba2-7f7f-4f3d-9cd1-25ad7ba7b3c9"
      data-name="freesvgillustration--uGJA8C--inject-30"
    >
      <path
        d="M253.58,472.6C248.66,461.75,236.11,456,224,459.05c-10.25,2.54-19.65,12-18.47,25.29a33.07,33.07,0,0,0,3.35,11,84.84,84.84,0,0,0,14.31,20.75c2.29,2.57,4.72,5,7.07,7.54.35-.31.59-.48.78-.67,3.09-3.33,6.29-6.53,9.24-10a72.43,72.43,0,0,0,13.24-21.2C256.05,485.35,256.46,479,253.58,472.6ZM246,481.89a15.55,15.55,0,1,1-15.29-15.8l.65,0A15.54,15.54,0,0,1,246,481.89Z"
        fill="#fff"
      />
    </g>
    <rect x={229.83} y={433.07} width={1.41} height={2.12} fill="#0071f2" />
    <path
      d="M231.25,429h-1.42v-4.12h1.42Zm0-8.22h-1.42v-4.11h1.42Z"
      fill="#0071f2"
    />
    <polygon
      points="231.25 412.55 229.83 412.55 229.83 409.91 232.35 409.13 232.77 410.49 231.25 410.96 231.25 412.55"
      fill="#0071f2"
    />
    <path
      d="M236.67,409.3l-.41-1.41,3.9-1.19.41,1.42Zm7.8-2.39-.41-1.41,3.91-1.19.41,1.35Zm7.82-2.37-.42-1.41,3.91-1.19.41,1.41Zm7.8-2.37-.41-1.42,3.9-1.19L264,401Zm7.8-2.38-.41-1.41,3.92-1.19.41,1.41Zm7.82-2.39-.41-1.34,3.9-1.19.41,1.42Zm7.8-2.37-.41-1.42,3.9-1.18.41,1.41Zm7.76-2.38-.41-1.41,3.9-1.19.41,1.42Zm7.8-2.37-.41-1.41,3.9-1.19L303,389Z"
      fill="#0071f2"
    />
    <rect
      x={306.67}
      y={386.24}
      width={2.12}
      height={1.41}
      transform="translate(-99.24 106.24) rotate(-16.91)"
      fill="#0071f2"
    />
    <path
      d="M309.4,389.18a2.66,2.66,0,1,0-3.31-1.78h0a2.62,2.62,0,0,0,3.26,1.78Z"
      fill="#0071f2"
    />
    <rect x={142.16} y={244.8} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={242.96} y={244.8} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={242.96}
      y={244.8}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <g
      id="b19b9aed-b730-475e-aa78-465cc5364efd"
      data-name="freesvgillustration--IaQ7Yo--inject-30"
    >
      <path
        d="M214.57,324a8.13,8.13,0,0,1-3.92,1.95c-.65.16-1.3.26-2,.38h-3.41c-1.13-.18-2.26-.32-3.39-.56a34.66,34.66,0,0,1-12.38-5.46A80.13,80.13,0,0,1,167.4,298,34.08,34.08,0,0,1,162,285.8c-.24-1.16-.39-2.33-.58-3.51V279a28.62,28.62,0,0,1,.75-3.17,21.38,21.38,0,0,1,1.42-2.83c.26.24.41.34.53.46q7,7.06,14,14a.79.79,0,0,1,.22.9,6.86,6.86,0,0,0,1.52,6.83,136.35,136.35,0,0,0,12.72,12.72,6.86,6.86,0,0,0,6.78,1.41.7.7,0,0,1,.81.14l14.13,14.23Z"
        fill="#fff"
      />
      <path
        d="M222.76,315.8q-2.46,2.49-4.93,4.94l-.35.32-14.35-14.33c.33-.31.72-.65,1.09-1l4.24-4.24a2.26,2.26,0,0,1,3.18-.46,2.05,2.05,0,0,1,.47.46q5.37,5.34,10.7,10.7a2.23,2.23,0,0,1,.43,3.14A2,2,0,0,1,222.76,315.8Z"
        fill="#fff"
      />
      <path
        d="M186.36,279.17c-1.83,1.78-3.69,3.52-5.53,5.26L166.7,270.3A2.22,2.22,0,0,1,167,270l5-5a2.23,2.23,0,0,1,3.13-.37,2.16,2.16,0,0,1,.37.37l10.81,10.81a2.2,2.2,0,0,1,.36,3.1A2.34,2.34,0,0,1,186.36,279.17Z"
        fill="#fff"
      />
    </g>
    <rect x={251.55} y={294.49} width={2.12} height={1.41} fill="#0071f2" />
    <path
      d="M270,295.9h-4.09v-1.41H270Zm-8.17,0h-4.09v-1.41h4.09Z"
      fill="#0071f2"
    />
    <rect x={274.12} y={294.49} width={2.12} height={1.41} fill="#0071f2" />
    <path
      d="M276.1,297.85a2.66,2.66,0,1,0-2.66-2.65,2.65,2.65,0,0,0,2.66,2.65Z"
      fill="#0071f2"
    />
    <rect x={150.19} y={51.9} width={100.8} height={100.8} fill="#0071f2" />
    <rect x={250.98} y={51.9} width={6.98} height={100.8} fill="#0071f2" />
    <rect
      x={250.98}
      y={51.9}
      width={6.98}
      height={100.8}
      opacity={0.1}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M218,88.52a16.85,16.85,0,1,1-16.65-17,16.85,16.85,0,0,1,16.65,17Z"
      fill="#fff"
    />
    <path d="M229.63,133.17h-58.1a29.09,29.09,0,0,1,58.1,0Z" fill="#fff" />
    <rect x={199.88} y={158.75} width={1.41} height={2.12} fill="#0071f2" />
    <path
      d="M201.29,177.29h-1.41v-4.1h1.41Zm0-8.21h-1.41V165h1.41Z"
      fill="#0071f2"
    />
    <polygon
      points="202.39 184.81 199.88 184.05 199.88 181.41 201.29 181.41 201.29 182.99 202.82 183.45 202.39 184.81"
      fill="#0071f2"
    />
    <path
      d="M272.62,206.21l-3.9-1.19.41-1.41,3.9,1.18Zm-7.8-2.38-3.9-1.18.41-1.42,3.9,1.2Zm-7.74-2.37-3.91-1.19.41-1.41,3.91,1.19Zm-7.81-2.37-3.9-1.19.41-1.42,3.9,1.19Zm-7.8-2.39-3.91-1.19.41-1.34,3.91,1.18Zm-7.81-2.38-3.9-1.18.41-1.42,3.9,1.19Zm-7.8-2.37-3.92-1.19.42-1.41,3.9,1.18ZM218,189.57l-3.9-1.18.41-1.42,3.9,1.19Zm-7.8-2.38-3.9-1.19.41-1.34,3.9,1.18Z"
      fill="#0071f2"
    />
    <rect
      x={277.09}
      y={205.99}
      width={1.41}
      height={2.12}
      transform="translate(-1.2 412.47) rotate(-73.06)"
      fill="#ffc727"
    />
    <path
      d="M277.91,209.85a2.65,2.65,0,1,0-1.77-3.32,2.65,2.65,0,0,0,1.77,3.32Z"
      fill="#0071f2"
    />
  </svg>
);
export default WebScrapingImg;
